import Vue from 'vue';

// register modal component
Vue.component('modal', {
  template: '#modal-template'
})

const modal = {
  template: '#modal-template'
}


// start app
new Vue({
  el: '#appFirst',
  components: {
    'data-component': modal,
  },
  data: {
    showModal: false
  }
})


Vue.component('modal-second', {
  template: '#modal-template-second'
})

const modalSecond = {
  template: '#modal-template-second'
}

new Vue({
  el: '#appSecond',
  components: {
    'data-component': modalSecond,
  },
  data: {
    showModal: false
  }
})
